import { render, staticRenderFns } from "./personnelinfo.vue?vue&type=template&id=afd63308&scoped=true&"
import script from "./personnelinfo.vue?vue&type=script&lang=js&"
export * from "./personnelinfo.vue?vue&type=script&lang=js&"
import style0 from "./personnelinfo.vue?vue&type=style&index=0&id=afd63308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd63308",
  null
  
)

export default component.exports